import { siteMeta, tickerItems } from '@/mocks/home';

export default function TopBar() {
  return (
    <div className="w-full bg-foreground-950 text-background-100">
      <div className="flex flex-wrap items-center justify-between gap-2 px-4 py-2 md:px-8">
        <div className="flex items-center gap-3">
          <span className="flex h-6 items-center gap-1.5 rounded-sm bg-primary-500 px-2 font-label text-[11px] font-medium tracking-wider text-background-50">
            <i className="ri-newspaper-line text-xs" />
            {siteMeta.issue}
          </span>
          <span className="font-label text-xs text-background-300">{siteMeta.dateLabel}</span>
        </div>
        <div className="hidden items-center gap-5 font-label text-xs text-background-300 md:flex">
          <a href="#editor" className="transition-colors hover:text-accent-400">
            编辑手记
          </a>
          <a href="#topics" className="transition-colors hover:text-accent-400">
            投稿与纠错
          </a>
          <a href="#subscribe" className="transition-colors hover:text-accent-400">
            订阅速览
          </a>
        </div>
      </div>

      <div className="flex items-stretch border-t border-background-50/10">
        <span className="flex shrink-0 items-center gap-1.5 bg-accent-500 px-3 font-label text-[11px] font-bold tracking-widest text-accent-950 md:px-4">
          <i className="ri-flashlight-fill" />
          快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker whitespace-nowrap py-2">
            {[...tickerItems, ...tickerItems].map((item, i) => (
              <span
                key={i}
                className="flex items-center gap-3 px-5 font-label text-xs text-background-200"
              >
                <i className="ri-record-circle-line text-[10px] text-primary-400" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}